// composables/useMaterials.ts
import { ref } from "vue";

export function useMaterials() {
  const materials = ref<any>(null);
  const error = ref<string | null>(null);
  const loading = ref(true);

  const fetchMaterials = async () => {
    loading.value = true;
    error.value = null;

    try {
      console.log("[useMaterials] Fetching...");
      const { data, error: fetchError } = await useFetch("/api/materials");

      if (fetchError.value) {
        throw new Error(fetchError.value);
      }

      console.log("[useMaterials] Data received:", data.value ? "✅" : "❌");

      if (!data.value) {
        console.warn("[useMaterials] Data is null, using empty fallback");
        materials.value = {
          key: "materials",
          titleKey: "studio.materials",
          items: [],
        };
      } else {
        materials.value = data.value;
      }
    } catch (err: any) {
      console.error("[useMaterials] Error:", err.message);
      error.value = err.message || "Failed to fetch materials";
      materials.value = {
        key: "materials",
        titleKey: "studio.materials",
        items: [],
      };
    } finally {
      loading.value = false;
    }
  };

  // Fetch immediately
  fetchMaterials();

  return {
    materials,
    error,
    loading,
    fetchMaterials,
  };
}
